// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__T2hYt","footerContainer":"footer_footerContainer__qbniZ","logo":"footer_logo__pSd0o","newsletter":"footer_newsletter__hJ6JU","links":"footer_links____wEb"};